(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[99416],{

/***/ 99416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ FAQ; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _shared_accordionItem__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76926);
/* harmony import */ var _faq_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25208);
/* harmony import */ var _faq_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_faq_module_scss__WEBPACK_IMPORTED_MODULE_3__);




function FAQ() {
    const { 0: activeTab , 1: setActiveTab  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(-1);
    const clickHandler = (idx)=>{
        if (idx === activeTab) {
            setActiveTab(-1);
            return;
        }
        setActiveTab(idx);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: `${(_faq_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["antivirus-gray-bg"])}`,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: `pt-12 px-4 py-2 text-left text-base`,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "md:flex w-full flex-column mb-8",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "md:w-6/12 md:pr-6 mb-6",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                        className: "text-xl font-bold mb-4",
                                        children: "What is an antivirus?"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        children: "An antivirus is a software program designed to detect and eliminate malware from computers and other devices. Antivirus solutions use machine learning, technical analysis, and AI to detect and remove any cybersecurity threats. Each antivirus solution listed above was thoroughly tested to ensure top-notch service quality, delivering real-time protection, online security, and comprehensive device security."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "md:w-6/12 md:pl-6 ",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                        className: "text-xl font-bold mb-4",
                                        children: "Why do I need an antivirus?"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        children: "In our interconnected world, where sensitive information is often stored online, cyber crimes have become some of the most prevalent offenses globally. Identity theft, fraud, and data breaches are more prevalent than ever, posing serious threats that require immediate remedy. Antiviruses emerge as an effective solution, acting as a shield against the most modern form of criminal activity."
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: `mb-8 pb-16 ${(_faq_module_scss__WEBPACK_IMPORTED_MODULE_3___default().border)}`,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                className: "text-xl font-bold mb-4",
                                children: "Disclaimer"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                children: [
                                    "At ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                        children: "AntivirusChoice"
                                    }),
                                    ", we keep a close eye on the latest deals to ensure you get the best prices available.",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                    " Our reviews remain unbiased, providing you with the honest opinions of cybersecurity experts and professionals. While we may earn commissions from referral links, we are not sponsored. Our commitment is to offer transparent and reliable information, empowering you to make well-informed choices."
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "pt-2 flex text-lg md:text-left md:text-sm px-4",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: `${(_faq_module_scss__WEBPACK_IMPORTED_MODULE_3___default().border)} flex flex-col lg:flex-row pb-16 w-full`,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "lg:w-6/12 w-full lg:pr-6",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                    className: "text-3xl font-bold mb-8",
                                    children: "Frequently Asked Questions"
                                }),
                                questions.map((item, idx)=>{
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        onClick: ()=>clickHandler(idx),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_accordionItem__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            title: item.title,
                                            body: item.body,
                                            isOpen: idx === activeTab
                                        })
                                    }, idx);
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "lg:w-6/12 pt-10 lg:pt-16 hidden md:flex flex-col lg:pl-6",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    children: [
                                        "IIf you're feeling overwhelmed by the rapid pace of change in the world, brace yourself; it's only going to get faster. The arrival of new technologies is speeding up, reshaping how we work, think, and live. At ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                            children: "AntivirusChoice"
                                        }),
                                        ", we are taking this fast ride with you, shoulder by shoulder-, to ensure that your cybersecurity is in safe hands. Let us handle the heavy lifting when it comes to selecting your next antivirus solution. We've thoroughly tested, examined, and reviewed the top antivirus options to guide you through all the ins and outs of each one."
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
const questions = [
    {
        title: "Can an antivirus solution really protect me against spyware, ransomware, and other malware?",
        body: "Each antivirus solution listed above has been thoroughly tested and proven to be an effective shield against spyware, ransomware, and all forms of malware."
    },
    {
        title: "Should I use free antivirus software?",
        body: "Yes, but not all of them. Some free antivirus solutions provide either fake or very limited protection. Typically, well-known antivirus brands offer free versions with restricted protection and security features to encourage users to upgrade to their premium solutions."
    },
    {
        title: "Which antivirus is best for mobile?",
        body: "All the antivirus solutions listed above offer comprehensive mobile applications that include many features found in the PC versions."
    }, 
];


/***/ }),

/***/ 76926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _accordionItem_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37366);
/* harmony import */ var _accordionItem_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_accordionItem_module_scss__WEBPACK_IMPORTED_MODULE_1__);


const AccordionItem = ({ title , body , isOpen  })=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: `flex flex-col ${(_accordionItem_module_scss__WEBPACK_IMPORTED_MODULE_1___default()["border-bottom"])}`,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex p-2 cursor-pointer items-center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: `rounded-md ${(_accordionItem_module_scss__WEBPACK_IMPORTED_MODULE_1___default().border)} bg-white w-8 h-8 flex items-center justify-center mr-8`,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            className: "w-3 h-3",
                            src: "/assets/question-mark.svg",
                            alt: ""
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: `text-base text-left ${(_accordionItem_module_scss__WEBPACK_IMPORTED_MODULE_1___default().question)}`,
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        className: `${isOpen ? "rotate-90" : ""} w-4 h-4 ml-auto transform transition-transform`,
                        src: "/assets/arrow.svg",
                        alt: ""
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: `${(_accordionItem_module_scss__WEBPACK_IMPORTED_MODULE_1___default().answer)} ${!isOpen ? "h-0 text-transparent" : "p-3"} text-sm `,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    children: body
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AccordionItem);


/***/ }),

/***/ 25208:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","border":"faq_border__MppCy","antivirus-gray-bg":"faq_antivirus-gray-bg__ZUmxC"};

/***/ }),

/***/ 37366:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"question":"accordionItem_question__a8c5X","answer":"accordionItem_answer__xDHHR","border-bottom":"accordionItem_border-bottom__WDKE9","border":"accordionItem_border__wRRJx"};

/***/ })

}]);